<template>
  <div class="subsector ricecultivation">
    <div class="parent-sector">
      <p>Agriculture</p>
    </div>
    <div class="content">
      <div class="row">
        <div class="col-md-6">
          <h1>Rice Cultivation</h1>
          <div class="row">
            <div class="col-sm">
              <p>
                Rice cultivation consists of CH₄ emissions from rice production.
                The anaerobic decomposition of organic matter (i.e.,
                decomposition in the absence of free oxygen) in flooded rice
                fields produces CH₄. When fields are flooded, aerobic
                decomposition of organic material gradually depletes the oxygen
                present in the soil and flood water, causing anaerobic
                conditions in the soil to develop. Once the environment becomes
                anaerobic, CH₄ is produced through anaerobic decomposition of
                soil organic matter by methanogenic bacteria. Several factors
                influence the amount of CH₄ produced, including water management
                practices and the quantity of organic material available to
                decompose.
              </p>
              <p>
                Rice cultivation is projected to account for 4% of total non-CO₂
                emissions by 2030. From 2015 through 2030, emissions are
                expected to decrease by 1%, largely due to increases in yield
                (i.e., rice produced per hectare) and decreased per capita
                demand for rice in the non-OECD Asia region. In 2030, roughly
                half of the available abatement can be achieved at relatively
                low prices.
              </p>
              <p>
                Approximately 28% of the potential abatement, or 62 MtCO₂e, can
                be abated at prices below $0/tCO₂e in 2030 with an additional
                26% reduction from baseline available at prices between $0 and
                $20/tCO₂e.
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <p class="center">
            <button
              @click="
                switchComponent('ChartRice1');
                activate(1);
              "
              :class="{ active: active_el == 1 }"
            >Projected Emissions</button>
            <button
              @click="
                switchComponent('ChartRice2');
                activate(2);
              "
              :class="{ active: active_el == 2 }"
            >Reduction Potential</button>
          </p>

          <div class="container">
            <component v-bind:is="currentComp"></component>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ChartRice1 from "@/components/agriculture/ChartRice1";
import ChartRice2 from "@/components/agriculture/ChartRice2";

export default {
  components: {
    ChartRice1,
    ChartRice2
  },
  data() {
    return {
      currentComp: "ChartRice1",
      active_el: 1
    };
  },
  methods: {
    switchComponent(comp) {
      //alert("test comp: " + comp);
      return (this.currentComp = comp);
    },
    activate: function(el) {
      this.active_el = el;
    }
  }
};
</script>

<style scoped>
h1 {
  font-weight: normal;
  font-size: 1.6rem;
  margin-bottom: 1rem;
}
.subsector {
  background: url("../../assets/bg-green-bar.png") 0 0 repeat-x;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
  border-radius: 5px;
}

.content {
  padding-top: 30px;
  padding-left: 50px;
  padding-right: 50px;
  position: absolute;
  top: 50px;
  left: 0;
  right: 0;
  bottom: 0;
  overflow-y: scroll;
  overflow-x: hidden;
  min-height: 0;
}
.keypoints {
  border-left-style: solid;
  border-left-width: 5px;
  border-left-color: #b8da66;
  margin-left: 2rem;
}
.keypoints h3 {
  text-transform: uppercase;
  text-align: left;
  font-size: 1rem;
  font-family: Arial, Helvetica, sans-serif;
  font-weight: bold;
  color: #333;
  margin-left: 1rem;
  margin-bottom: 1rem;
}
.keypoints ul {
  margin-left: 1.5rem;
}
.keypoints li {
  display: list-item;
  list-style-type: disc;
  margin-bottom: 0.8rem;
}
img {
  float: right;
  margin-top: 50px;
}
button {
  background-color: #0071bc;
  border-radius: 3px;
  border: 0;
  color: #fff;
  font-size: 1rem;
  padding: 0.25rem 0.5rem;
  margin-top: 2rem;
  cursor: pointer;
  margin-left: 1rem;
}
.parent-sector {
  position: static;
  color: #28530a;
  z-index: 1;
  font-weight: bold;
  font-size: 1.2rem;
  padding-top: 10px;
  margin-left: 50px;
}

.center button {
  position: static !important;
}
</style>
